import { trackBannerImpression } from "@services/tracking/trackers/bannerImpressionTracker";
import { trackButtonImpression } from "@services/tracking/trackers/buttonImpressionTracker";
import { trackPageImpression } from "@services/tracking/trackers/pageImpressionTracker";
import { trackProductImpressionFromNode } from "@services/tracking/trackers/productImpressionTracker";
import { trackSectionImpression } from "@services/tracking/trackers/sectionImpressionTracker";
import { EventTypes } from "@services/tracking/types/eventTypes";

import {
    elementHasBeenTracked,
    setElementHasBeenTracked,
} from "../trackers/utils";

let impressionElements: Array<HTMLElement> | undefined;
let observer: IntersectionObserver;

const trackGenericImpressions = (): void => {
    impressionElements = Array.from(
        document.querySelectorAll(`[data-tracking-event$="-impression"]`),
    );

    observer = new IntersectionObserver((entries): void => {
        entries.forEach((entry): void => {
            if (entry.intersectionRatio > 0) {
                const target: HTMLElement = entry.target as HTMLElement;
                trackImpressionByType(target);
            }
        });
    });

    impressionElements.forEach(impressionElement => {
        observer.observe(impressionElement);
    });
};

const trackImpressionByType = (element: HTMLElement) => {
    if (!elementHasBeenTracked(element)) {
        setElementHasBeenTracked(element);

        const eventType: EventTypes =
            (element.dataset.trackingEvent as EventTypes) || EventTypes.NONE;

        switch (eventType) {
            case EventTypes.ButtonImpression:
                trackButtonImpression(element);
                break;

            case EventTypes.PageImpression:
                trackPageImpression();
                break;

            case EventTypes.SectionImpression:
                trackSectionImpression(element);
                break;

            case EventTypes.ProductImpression:
                trackProductImpressionFromNode(element);
                break;

            case EventTypes.BannerImpression:
                trackBannerImpression(element);
                break;
        }
    }
};

export { trackGenericImpressions };
